<template>
	<div v-if="visible" v-loading="loading" class="onboarding">
		<div class="onboarding-content">
			<div class="onboarding-content-logo"></div>
			<h1>
				Welcome back!
			</h1>
			<el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="handleSubmit('form')">
				<el-form-item prop="email">
					<el-input v-model="form.email" suffix-icon="el-icon-message" placeholder="Email" ref="email"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input v-model="form.password" suffix-icon="el-icon-lock" type="password" placeholder="Password"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-between">
						<router-link to="/forgotten-password">Forgotten password?</router-link>
						<el-button native-type="submit" type="primary" v-loading.fullscreen.lock="loading" plain>Login</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'
import { HTTP } from '@/services/api'

export default {
	name: 'Login',
	metaInfo () {
		return {
			title: 'Login'
		}
	},
	data() {
		return {
			api: process.env.VUE_APP_API,
			visible: false,
			loading: false,
			form: {
				email: '',
				password: ''
			},
			rules: {
				email: [
					{ required: true, message: 'Please enter email', trigger: 'blur' },
					{ type: 'email', message: 'Please enter correct email', trigger: 'blur' }
				],
				password: [
					{ required: true, message: 'Please enter password', trigger: 'blur' },
				]
			}
		}
	},
	computed: {
        ...mapState(['auth'])
	},
	created () {
		if (this.auth.access_token) {
			this.$router.push('/analytics')
		}
	},
	mounted () {
		if (!this.auth.access_token) {
			this.visible = true
			Vue.nextTick(() => {
				this.$refs.email.focus()
			})
		}
	},
	methods: {
		loadUserData () {
			HTTP({
				method: 'GET',
				url: '/users/me',
				crossdomain: true
			})
			.then(response => {
				this.$store.dispatch('setUser', response.data).then(() => {
					this.$router.push('/analytics')
				})
			})
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					let formData = new FormData()
					formData.append('grant_type', 'password')
					formData.append('client_id', process.env.VUE_APP_CLIENT_ID)
					formData.append('client_secret', process.env.VUE_APP_CLIENT_KEY)
					formData.append('username', this.form.email)
					formData.append('password', this.form.password)
					axios({
						method: 'POST',
						url: this.api + '/oauth/token',
						crossdomain: true,
						data: formData
					})
					.then(response => {
						this.$store.dispatch('setAuth', response.data).then(() => {
							this.loadUserData()
						})
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
